const EXTERNAL_SESSION_STORAGE_KEY = 'aline-external-session';

/**
 * Whether this browser tab has opened a task as an external assignee. External assignees are
 * ordinary users on the server, so the tab remembers it to keep them in the external view
 * after a reload or a hand-typed URL. Scoped to the tab through sessionStorage.
 */
export function getIsExternalSession(): boolean {
  return sessionStorage.getItem(EXTERNAL_SESSION_STORAGE_KEY) === '1';
}

export function setExternalSession(): void {
  sessionStorage.setItem(EXTERNAL_SESSION_STORAGE_KEY, '1');
}

export function clearExternalSession(): void {
  sessionStorage.removeItem(EXTERNAL_SESSION_STORAGE_KEY);
}
